<template>

  <div class="store-warp" v-if="type==1 && storelength">
    <div class="store-list">
       <div class="store-item" :class="{'store-block': mstore.length == 1}" v-for="item in mstore" :key="item.storeId" @click="goNearby(item)">
         <div class="store-img">
           <img v-if="item.storeImg" :src="item.storeImg | imageToHttps | imageToWebp($webpSurpport)" alt="">
           <img v-else :src="getDefaultImageUrl(item)" alt="">
         </div>
         <div class="store-body">
            <h4>{{item.storeAliasName}}</h4>
            <div><span class="icon-shop"></span><span class="icon-guanfang"></span></div>
         </div>
      </div>
      <div class="store-more" v-if="storelength > 5" @click="more()">
        <i></i>
        <p>查看更多</p>
      </div>
    </div>
  </div>

  <div class="nearby-shop" v-else-if="type==0">
    <div class="nearby-title">
      <h4>附近好店</h4>
      <a href="javascript:;" @click="look">查看 <i></i></a>
    </div>
    <div class="shop-title" @click="look">
      <h4><p>{{store.storeName}}</p> <!--<span>官方认证</span>--></h4>
      <p>距您{{store.distance | fixedDistance}}{{store.distance > 1000 ? 'km' : 'm'}}</p>
    </div>
    <div class="shop-product" @click="look">
      <img v-for="(img, index) in productImgUrl" :key="index" :src="img.defaultImageUrl">
    </div>
  </div>
</template>

<script>

export default {
  name: 'nearbyShop',
  props: {
    store: {
      type: Object,
      default: () => {}
    },
    mstore: {
      type: Array,
      default: () => []
    },
    storelength: {
      type: Number,
      default: () => 0
    },
    type: {
      type: Number,
      default: () => 0
    },
    productImgUrl: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    // 处理距离
    fixedDistance(value) {
      try {
        if (value >= 1000) {
          value = value / 1000
          return value.toFixed(1)
        } else {
          return value
        }
      } catch {
        return 0
      }
    },
  },
  methods: {
    getDefaultImageUrl(store) {
      if (this.$util.isSyBird() || Number(store.synStoreType) !== 9) {
        return `${this.$cdnImageUrl}/sybird_default_logo.png`
      } else {
        return `${this.$cdnImageUrl}/zhijia.png`
      }
    },
    more() {
      this.$router.push('/vipstore')
    },
    look() {
      // 埋点
      this.$util.gioTrackWithVariable('MB15597', {
        storeId: this.store.storeId ? this.store.storeId + '' : 'null'
      })
      this.$router.push({
        path: '/shopDetail',
        query: {
          storeId: this.store.storeId,
          mdCode: this.store.mdCode || ''
        }
      })
    },
    goNearby(item) {
      // 埋点
      this.$util.gioTrackWithVariable('MB15596', {
        storeId: item.storeId ? item.storeId + '' : 'null'
      })
      this.$router.push({
        path: '/shopDetail',
        query: {
          storeId: item.storeId,
          mdCode: item.mdCode || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.store-warp{
  margin: .12rem .32rem .24rem .32rem;
  padding: .24rem .2rem;
  height: 1.32rem;
  // background: #fff;
  background: rgba(255,255,255,0.80);
  border-radius: .24rem;
  @include synShadow;
}

.store-list{
  height: 1.8rem;
  white-space: nowrap;
  overflow-x: auto;
}

.store-item{
  position: relative;
  margin-right: .16rem;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  width: 4.85rem;
  height: 1.3rem;
  padding: .16rem .24rem;
  box-sizing: border-box;
  border-radius: .16rem;
  vertical-align: top;
  background: #ecf3fa;
  &::after{
    content: '';
    position: absolute;
    top: .3rem;
    right: .3rem;
    display: block;
    width: .82rem;
    height: .72rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/hom-shop-item-bg.png) 90% center no-repeat;
    background-size: cover;
    z-index: 0;
  }
  &:last-child{
    margin-right: 0;
  }
}

.store-img{
  margin-right: .18rem;
  img{
    width: .84rem;
    height: .84rem;
    background: #C0D7FF;
    border-radius: .2rem;
  }
}

.store-body{
  display: flex;
  flex-direction: column;
  h4{
    width: 3.1rem;
    position: relative;
    font-size: .28rem;
    color: #333333;
    font-weight: 500;
    z-index: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  div{
    padding-top: .12rem;
    span{
      margin-right: .12rem;
      display: inline-flex;
      width: .98rem;
      height: .24rem;
      vertical-align: middle;
    }
  }
  .icon-shop{
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/vip_tag.png) no-repeat;
    background-size: cover;

  }
  .icon-guanfang{
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/gf_tag.png) no-repeat;
    background-size: cover;
  }
}

.store-block{
  width: 6.38rem;
  h4{
    width: 4.8rem;
  }
}

.store-more{
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 1.34rem;
  padding: 0 .1rem;
  vertical-align: top;
  i{
    display: block;
    width: .48rem;
    height: .48rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/more.png) no-repeat;
    background-size: cover;
  }
  p{
    margin-top: .08rem;
    font-size: .24rem;
    color: #999;
    line-height: .36rem;
  }
}

.nearby-shop{
  margin: .12rem .32rem .24rem .32rem;
  padding: .24rem;
  background: rgba(255,255,255,0.80);
  border-radius: .24rem;
  @include synShadow;
}
.nearby-title{
  @include home-title;
  padding-top: 0;
}

.shop-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .24rem;
  h4{
    display: flex;
    align-items: center;
    p{
      max-width: 4rem;
      font-size: .28rem;
      line-height: .3rem;
      color: #333;
      font-weight: 500;
      @include text-overflow(1);
    }
    span{
      margin-left: .12rem;
      display: inline-flex;
      padding: .04rem .08rem;
      font-size: .16rem;
      background: #E2ECFB;
      color: $themeSynMain;
      border-radius: .04rem;
    }
  }
  > p{
    font-size: .22rem;
    color: #666;
  }
}

.shop-product{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 1.52rem;
  img{
    margin-right: .1rem;
    width: 1.52rem;
    height: 1.52rem;
    border-radius: .16rem;
  }
}

</style>
